export default __webpack_public_path__ + "static/media/string.6fedf0f1.jpg";